const form = document.querySelector('form');
let qMarks = form.querySelectorAll('.q-mark');
let closeBtn = form.querySelectorAll('.close-tooltip');

for (let i = 0; i < closeBtn.length; i++) {
		closeBtn[i].addEventListener('click', function () {
				let parent = this.parentElement.parentElement;
				parent.classList.add('hidden');
		})
}

for (let i = 0; i < qMarks.length; i++) {
		qMarks[i].addEventListener('click', function () {
				let tooltip = this.nextElementSibling;
				tooltip.classList.remove('hidden');
		})
}
